import { Link } from 'react-router-dom';
import { Logo } from '@/components/shared/logo';

export function PublicFooter() {
  return (
    <footer className="border-t border-(--color-border) bg-(--color-background)">
      <div className="mx-auto grid max-w-7xl gap-8 px-4 py-12 sm:px-6 md:grid-cols-4 lg:px-8">
        <div className="space-y-3 md:col-span-2">
          <Logo />
          <p className="max-w-sm text-sm text-(--color-muted-foreground)">
            Cryptographically verified candidate profiles. Built for hiring teams who need
            evidence, not adjectives.
          </p>
        </div>

        <div>
          <h3 className="text-sm font-semibold">Product</h3>
          <ul className="mt-3 space-y-2 text-sm text-(--color-muted-foreground)">
            <li><Link to="/#features" className="hover:text-(--color-foreground)">Features</Link></li>
            <li><Link to="/#how" className="hover:text-(--color-foreground)">How it works</Link></li>
            <li><Link to="/#pricing" className="hover:text-(--color-foreground)">Pricing</Link></li>
            <li><Link to="/public/case-lookup" className="hover:text-(--color-foreground)">Verify a case</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-semibold">Legal</h3>
          <ul className="mt-3 space-y-2 text-sm text-(--color-muted-foreground)">
            <li><Link to="/terms" className="hover:text-(--color-foreground)">Terms</Link></li>
            <li><Link to="/privacy" className="hover:text-(--color-foreground)">Privacy</Link></li>
            <li><Link to="/cookies" className="hover:text-(--color-foreground)">Cookies</Link></li>
            <li><Link to="/help" className="hover:text-(--color-foreground)">Help</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-(--color-border)">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-4 text-xs text-(--color-muted-foreground) sm:flex-row sm:px-6 lg:px-8">
          <span>&copy; {new Date().getFullYear()} Tally Labs. All rights reserved.</span>
          <span>Made with verifiable trust.</span>
        </div>
      </div>
    </footer>
  );
}
